import { getCorridorCorners } from "./index104.js";
import { V3toVector3, applyTransform, getPivot } from "@project-rouge/rg-three";
function getModuleSizeZ(module, apartment) {
	if (apartment.data.closeCorridor && apartment.data.closeDirection) {
		const { start: corridorStart } = getCorridorCorners(module, apartment);
		return V3toVector3(applyTransform(getPivot([
			0,
			0,
			0
		], module), apartment)).distanceTo(V3toVector3(corridorStart));
	}
	return module.size[2];
}
export { getModuleSizeZ };

//# sourceMappingURL=index106.js.map